import React from "react";
import { TimeDisplayWrapper } from "../styledComponents";
import { BreakDisplay } from "./BreakDisplay";
import { TimesheetsShiftInfo } from "../../../types/Shift.types";
import { PayrollHoursStatus } from "../../../types/Payroll.types";

type BreakCellProps = {
  shiftInfo: TimesheetsShiftInfo;
  openModal: () => void;
  showMessaging?: boolean;
  shiftKey: string;
};

export const BreakCell = ({ shiftInfo, openModal, showMessaging, shiftKey }: BreakCellProps) => {
  const showApproval = shiftInfo.userShift.status === PayrollHoursStatus.APPROVED;

  return (
    <TimeDisplayWrapper onClick={openModal} showApproval={showApproval}>
      <BreakDisplay
        shiftBreak={shiftInfo.userShift.break}
        shiftInfo={shiftInfo}
        shiftKey={shiftKey}
        showMessaging={showMessaging}
      />
    </TimeDisplayWrapper>
  );
};
